


export class ProfileLotView {
    constructor() {

        this.template = document.querySelector('#lot-template');
        this.container = document.querySelector('section.sc_items div.ul');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const data = state.data;


        const section = document.querySelector('section.sc_items');
        if (section) {

            const title = section.querySelector('div.sc_title strong');
            if (title) { title.textContent = data.title;}

            const count = section.querySelector('div.sc_title em');
            if (count) { count.textContent = data.totalCount;}

            const url = section.querySelector('a.sc_header');
            if (url) {

                url.href = data.url;

                if (data.totalCount > 6) {
                    const more = url.querySelector('div.sc_more');
                    if (more) { more.style.display = '';}
                }
            }
        }

        if (!data.models.length) {

            section.classList.add('empty');
            section.querySelector('div.scroll_slider').remove();
            //section.querySelectorAll('div.ul .li').forEach(el => el.remove());

            const emptyBody = section.querySelector('.sc_body_empty');
            if (emptyBody && data.addUrl != false) {

                const addLink = document.createElement('a');
                addLink.classList.add('add_button');
                addLink.textContent = data.addUrl.tip;
                addLink.href = data.addUrl.url;
                emptyBody.appendChild(addLink);
            }

            emptyBody.style.display = '';

            return;
        }

        const container = this.container;
        let next = container.nextElementSibling;


        const slides = this.container.querySelectorAll('.li.slide');
        let index = 0;

        slides.forEach(slide => {

            const dummies = slide.querySelectorAll('div.item'); 
            dummies.forEach(dummy => {

                if (!data.models[index]) {
                    dummy.closest('.item').remove();
                    return;
                }

                const model = data.models[index];

                const l = this.renderPartial(model);

                dummy.replaceWith(l);

                index += 1;

            });
			
			//подчистка слайда, если он остался пустым:
			if (slide.textContent.trim() === '') { slide.remove();}
        });
    }

    renderPartial(data) {

        const p = this.template.content.cloneNode(true);
        const article = p.querySelector('article.lot');
        if (article) {

            article.classList.remove('dummy');
            if (data.classes && data.classes.length > 0) {
                article.classList.add(...data.classes);
            }

            const preview = article.querySelector('a.preview');
            if (preview) {
                preview.href = data.url;
            }

            const img = article.querySelector('img');
            if (img) {

                img.src = data.image;
                img.dataset.src = data.image;
                img.alt = data.title;
            }

            const title = article.querySelector('a.title');
            if (title) {

                title.href = data.url;
                title.textContent = data.title;
            }

            const price = article.querySelector('div.current');
            if (price) {

                const value = price.querySelector('p');
                if (value) { value.textContent = data.price;}

                const currency = price.querySelector('span');
                if (currency) {
                    currency.textContent = data.currency;
                }
            }


        }

        return p.firstElementChild;
    }
}